import React, { Component } from 'react';
import moment from 'moment';
moment.locale('es')

/**
 * Evento para cancelar el scroll en input number
 */
document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

/**
 * Clase para ver el detalle de un inventario
 */
export default class MyTable extends Component {
    state = {
        dataMermas: []
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        
    }

    render() {
        return (
            <>
                {(this.props.tipoMerma.recetas.length > 0) ?<>
                    <tr style={{fontWeight: "bold"}}>
                        <td>{'Fecha'}</td>
                        <td>{'Documento'}</td>
                        <td>{'Descripcion'}</td>
                        <td>{'Empleado'}</td>
                        <td>{'Articulo'}</td>
                        <td>{'Unidad'}</td>
                        <td style={{textAlign: "right"}}>{'Cantidad'}</td>
                        <td style={{textAlign: "right"}}>{'Costo Unitario'}</td>
                        <td style={{textAlign: "right"}}>{'Costo Total'}</td>
                    </tr> 
                    {
                        this.props.tipoMerma.recetas.map((item) => (
                            <React.Fragment key={item.recetaKey}>
                                <tr onClick={() => this.props.toggleRowReceta(item)} style={{backgroundColor: "#c5e4f5ff", fontWeight: "bold", color: (item.detail[0].folioSAP == "" && !this.props.esBarra) ? '#E74C3C' : "000000ff"}}>
                                    <td>{moment(item.fecha).format("DD/MM/YYYY, h:mm a")}</td>
                                    <td>{item.numDoc}</td>
                                    <td>{item.descripcion}</td>
                                    <td>{item.empleado}</td>
                                    <td style={{textAlign: "right"}}>{ this.props.esBarra ? item.conteo: ''}</td>
                                    <td colSpan="2"></td>
                                    <td colSpan="2" style={{textAlign: "right"}}>{this.props.currencyFormat(item.costoTotal)}</td>
                                </tr>
                                {item.open && (
                                     item.detail.map((item2) => (
                                        <React.Fragment key={item2.id}>
                                            <tr className={(item2.folioSAP == "" && !this.props.esBarra) ? "row-error":""}>
                                                <td colSpan="3"></td>
                                                <td colSpan="2">{item2.codigo + " - " + item2.articulo}</td>
                                                <td>{item2.unidad}</td>
                                                <td style={{textAlign: "right"}}>{item2.cantidad}</td>
                                                <td style={{textAlign: "right"}}>{this.props.currencyFormat(item2.costo)}</td>
                                                <td style={{textAlign: "right"}}>{this.props.currencyFormat(item2.costoTotal)}</td>
                                            </tr>
                                        </React.Fragment>
                                    ))
                                )}
                            </React.Fragment>
                        ))
                    }
                </>:<>
                    <tr style={{fontWeight: "bold"}}>
                        <td>{'Fecha'}</td>
                        <td>{'Documento'}</td>
                        <td colSpan="2">{'Empleado'}</td>
                        <td>{'Articulo'}</td>
                        <td>{'Unidad'}</td>
                        <td style={{textAlign: "right"}}>{'Cantidad'}</td>
                        <td style={{textAlign: "right"}}>{'Costo Unitario'}</td>
                        <td style={{textAlign: "right"}}>{'Costo Total'}</td>
                    </tr> 
                    {
                        this.props.tipoMerma.detail.map((item) => (
                            <React.Fragment key={item.id}>
                                <tr className={(item.folioSAP == "" && !this.props.esBarra)? "row-error":""}>
                                    <td>{moment(item.fecha).format("DD/MM/YYYY, h:mm a")}</td>
                                    <td>{item.numDoc}</td>
                                    <td colSpan="2">{item.empleado}</td>
                                    <td>{item.codigo + " - " + item.articulo}</td>
                                    <td>{item.unidad}</td>
                                    <td style={{textAlign: "right"}}>{item.cantidad}</td>
                                    <td style={{textAlign: "right"}}>{this.props.currencyFormat(item.costo)}</td>
                                    <td style={{textAlign: "right"}}>{this.props.currencyFormat(item.costoTotal)}</td>
                                </tr>
                            </React.Fragment>
                        ))
                    }
                </>}
            </>
        )
    }

}

/*
import React, { useState } from 'react';

export default class Mytabla extends Component {
    state {  } 
    return (
        <> {
            data.map((item) => (
                <React.Fragment key={item.id}>
                    <tr onClick={() => this.toggleRow(item)}>
                        <td>{item.name}</td>
                        <td>{item.conteo}</td>
                        <td>{item.costoTotal}</td>
                        <td>{item.open? 'OPEN': 'CLOSE'}</td>
                    </tr>
                </React.Fragment>
            ))
        }</>
    );
}*/